var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6328 19.7848C22.5059 27.1949 12.3379 29.3543 6.5096 23.5802C0.794668 17.9184 2.56397 7.66104 10.0785 4.375",
    stroke: "#2177FE",
    strokeWidth: 1.88,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1039 15.625C24.4635 15.625 25.6432 15.625 26.4052 14.5687C26.4336 14.5293 26.481 14.4584 26.5065 14.417C27.1908 13.3089 26.8382 12.4575 26.1329 10.7547C25.4933 9.21066 24.5559 7.80769 23.3741 6.62592C22.1923 5.44414 20.7893 4.5067 19.2453 3.86713C17.5425 3.16182 16.6911 2.80917 15.583 3.49346C15.5416 3.51903 15.4707 3.56636 15.4313 3.59483C14.375 4.35675 14.375 5.53653 14.375 7.89608V10.5343C14.375 12.9341 14.375 14.134 15.1205 14.8795C15.866 15.625 17.0659 15.625 19.4656 15.625H22.1039Z",
    stroke: "#2177FE",
    strokeWidth: 1.88
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataActiveIcon);
export default __webpack_public_path__ + "static/media/dataActiveIcon.17b043d87e762c1bfc8a383f45e7550b.svg";
export { ForwardRef as ReactComponent };